import { Typography } from "@mui/material"
import { TSaleItemStorage } from "../../../core/types/Sale"
import { Trans } from "react-i18next"

interface TicketDeliverySectionProps {
  items: TSaleItemStorage[]
  customerEmail: string
}

const TicketDeliverySection = ({
  items,
  customerEmail,
}: TicketDeliverySectionProps) => {
  const isNominal = items.some((item) => item.requireNominalAtCheckout === true)

  return (
    <>
      {isNominal ? (
        <Typography variant="body1" sx={{ marginBottom: 3 }}>
          <Trans
            i18nKey="postPurchase.ticket.nominal"
            components={{ email: <strong>{customerEmail}</strong> }}
          />
        </Typography>
      ) : (
        <Typography variant="body1" sx={{ marginBottom: 3 }}>
          <Trans
            i18nKey="postPurchase.ticket.link"
            components={{ email: <strong>{customerEmail}</strong> }}
          />
        </Typography>
      )}
    </>
  )
}

export default TicketDeliverySection
